import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AppFacadeService } from '@services/app-facade.service';
import { environment } from '@environments/environment';

/**
 * Handles all API HTTP request and 
 * logs them on the API.
 */
@Injectable({
    providedIn: 'root'
})
export class LoggerRequestInterceptor implements HttpInterceptor {
    /**
     * Object that contains all the petition data
     * that will be logged on the Data base through
     * the API.
     */
    mapRequest: { key: string, value: any } = { key: "", value: null }

    /**
     * HeaderInterceptor Constructor
     * @param appFacadeService The Facade service of the app for managing the requests logs.
     */
    constructor(
        private appFacadeService: AppFacadeService,
    ) { }

    /**
     * This method logs the app requests on the database 
     * through the API when {@link environment} version
     * includes VERBOSE and the request path is different
     * from maintenance/logger.
     * @param request
     * @param next 
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isVerbose = environment.version.includes("VERBOSE");
        const allowRequest = request.url.includes("maintenance/logger")
        if (isVerbose && !allowRequest) {
            this.mapRequest[request.url] = request.body == null ? {} : request.body
        }
        return next.handle(request)
            .pipe(
                tap(evt => {
                    if ((evt instanceof HttpResponse) && isVerbose && !allowRequest) {
                        const responseBody = evt.body == null ? {} : evt.body
                        this.appFacadeService.loggerRequest({
                            request: JSON.stringify(this.mapRequest[evt.url]),
                            response: JSON.stringify(responseBody),
                            url: evt.url,
                            version: environment.version
                        })
                    }
                }),
            );
    }
}